export  enum PropertyStatusEnum {
    Draft = 0,
    Private = 10,
    Public = 11,
    OffMarket = 12,
    PrivateInvestorAllowed = 13,
    Sold = 20,
}

